const documentTypeServiceName = "/DocumentType";

export function documentTypeService (http) {
    return {
        getAllDocumentTypesAsync: async () => {
            return await http.get(documentTypeServiceName + '/GetAllDocumentTypesAsync');
        }
    }
}